/**
 * Looping background music. Files are generated by scripts/generate-audio.mjs
 * (see ASSET.md section 8.1) and loaded by PreloadScene; call `init()` once
 * (done in BootScene) before `play()`.
 */

import Phaser from 'phaser';
import { SaveData } from './SaveData';

type LoopType = 'menu' | 'game';

const TRACK_KEY: Record<LoopType, string> = {
  menu: 'music_menu_loop',
  game: 'music_theme_loop'
};

let sound: Phaser.Sound.BaseSoundManager | null = null;
let enabled = SaveData.getSettings().musicOn;
let current: Phaser.Sound.BaseSound | null = null;
let currentType: LoopType | null = null;

export const Music = {
  init(soundManager: Phaser.Sound.BaseSoundManager): void {
    sound = soundManager;
  },

  play(type: LoopType): void {
    if (currentType === type) return;
    this.stop();
    currentType = type;
    if (!enabled || !sound) return;
    current = sound.add(TRACK_KEY[type], { loop: true, volume: 0.5 });
    current.play();
  },

  stop(): void {
    current?.stop();
    current?.destroy();
    current = null;
    currentType = null;
  },

  isEnabled(): boolean {
    return enabled;
  },

  setEnabled(value: boolean): void {
    enabled = value;
    SaveData.setMusicOn(value);
    if (!value) {
      current?.stop();
      current?.destroy();
      current = null;
    } else if (currentType) {
      const type = currentType;
      currentType = null;
      this.play(type);
    }
  }
};
